import { bopApi } from '@/lib/api/client';

// PATH ASYMMETRY IS DELIBERATE: the GET endpoint has no suffix, but the PUT
// endpoint targets the /healthy sub-resource. Do not "normalise" these.
const READ_REPLICAS_PATH = 'v1/devops/questdb/read-replicas';
const READ_REPLICAS_HEALTHY_PATH = `${READ_REPLICAS_PATH}/healthy`;

export interface ReadReplica {
  ip: string;
  name: string | null;
  healthy: boolean;
}

export interface ReadReplicaState {
  replicas: ReadReplica[];
  /** IGNORE — redundant with `replicas[].healthy`; always derive healthy IPs from `replicas`. */
  healthyIps: string[];
  /** Healthy IPs still recorded in Redis that are no longer in the available replica set. */
  orphanedHealthyIps: string[];
  canEdit: boolean;
}

export const getReadReplicas = () => bopApi.get(READ_REPLICAS_PATH).json<ReadReplicaState>();

// The server rejects unknown IPs with a 400 whose message callers must surface.
export const putHealthyIps = (healthyIps: string[]) => bopApi.put(READ_REPLICAS_HEALTHY_PATH, { json: { healthyIps } }).json<ReadReplicaState>();
